module.exports = __webpack_public_path__ + "static/media/zoom_out.58f38038.svg";